export default function ReportsPage() {
  return <div style={{ padding: 24 }}><h2>Reports — Coming Sprint 2</h2></div>
}
